import React from 'react';
import { motion } from 'framer-motion';
import { Shield, Zap, FileText, Dog, CreditCard, Lock } from 'lucide-react';
export function HeroSection() {
  return <section className="relative pt-12 pb-20 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto flex flex-col items-center text-center" data-id="element-195">
      <motion.div initial={{
      opacity: 0,
      y: -20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.6
    }} className="mb-8" data-id="element-196">
        <span className="text-gold-400 font-semibold tracking-wider uppercase text-sm md:text-base flex items-center justify-center gap-2" data-id="element-197">
          🐾 MUNDORECURSOS™
        </span>
      </motion.div>

      <motion.h1 initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.6,
      delay: 0.1
    }} className="text-4xl md:text-6xl lg:text-7xl font-bold text-white mb-6 leading-tight" data-id="element-198">
        Todo tu proceso con tu perro resuelto.{' '}
        <br className="hidden md:block" data-id="element-199" />
        <span className="text-gold-400 block mt-2 text-3xl md:text-5xl" data-id="element-200">
          GUÍA DEL PERRO TRANQUILO™ Combo Completo
        </span>
      </motion.h1>

      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.6,
      delay: 0.2
    }} className="text-lg md:text-xl text-blue-100 max-w-3xl mx-auto mb-10 space-y-4" data-id="element-201">
        <p className="italic text-gold-400/90 font-medium" data-id="element-202">
          "Listo para usar. Sin buscar más. Sin improvisar. Sin volver a casa
          con miedo de lo que vas a encontrar."
        </p>
        <p data-id="element-203">Tu proceso completo de 21 días — listo para aplicar desde hoy.</p>
      </motion.div>

      <motion.div initial={{
      opacity: 0,
      scale: 0.95
    }} animate={{
      opacity: 1,
      scale: 1
    }} transition={{
      duration: 0.8,
      delay: 0.3
    }} className="relative w-full max-w-2xl mx-auto mb-12" data-id="element-204">
        <div className="absolute inset-0 bg-gold-500/20 blur-3xl rounded-full" data-id="element-205"></div>
        <img src="https://cdn.magicpatterns.com/uploads/cA3xKv9M82YN4PWrqTA4WW/Gemini_Generated_Image_b0srjcb0srjcb0sr.png" alt="Guía del Perro Tranquilo - MegaPack" className="relative z-10 w-full h-auto drop-shadow-2xl" data-id="element-206" />
      </motion.div>

      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.6,
      delay: 0.4
    }} className="flex flex-wrap justify-center gap-4 md:gap-8 mb-10 text-sm md:text-base font-medium text-blue-50" data-id="element-207">
        <div className="flex items-center gap-2" data-id="element-208">
          <FileText className="w-5 h-5 text-gold-400" data-id="element-209" /> 100% PDF
        </div>
        <div className="flex items-center gap-2" data-id="element-210">
          <Zap className="w-5 h-5 text-gold-400" data-id="element-211" /> Acceso Inmediato
        </div>
        <div className="flex items-center gap-2" data-id="element-212">
          <Dog className="w-5 h-5 text-gold-400" data-id="element-213" /> Todos los perros
        </div>
        <div className="flex items-center gap-2" data-id="element-214">
          <Shield className="w-5 h-5 text-gold-400" data-id="element-215" /> Garantía 7 días
        </div>
      </motion.div>

      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.6,
      delay: 0.5
    }} className="w-full max-w-md mx-auto" data-id="element-216">
        <a href="#pricing" className="block w-full py-4 px-8 bg-gradient-to-r from-gold-500 to-gold-400 hover:from-gold-400 hover:to-gold-300 text-navy-900 font-bold text-lg md:text-xl rounded-full shadow-[0_0_20px_rgba(212,168,83,0.4)] hover:shadow-[0_0_30px_rgba(212,168,83,0.6)] transition-all transform hover:-translate-y-1" data-id="element-217">
          💪 → QUIERO MI GUÍA AHORA
        </a>

        <div className="mt-6 flex flex-wrap justify-center items-center gap-3 text-xs md:text-sm text-blue-200/70" data-id="element-218">
          <div className="flex items-center gap-1" data-id="element-219">
            <CreditCard className="w-4 h-4" data-id="element-220" /> Mercado Pago
          </div>
          <span data-id="element-221">|</span>
          <div data-id="element-222">Tarjeta</div>
          <span data-id="element-223">|</span>
          <div data-id="element-224">Transferencia</div>
          <span data-id="element-225">|</span>
          <div className="flex items-center gap-1" data-id="element-226">
            <Lock className="w-4 h-4" data-id="element-227" /> Pago 100% seguro
          </div>
        </div>
      </motion.div>
    </section>;
}